import { render, staticRenderFns } from "./w8benPage.vue?vue&type=template&id=3ec25875&scoped=true&"
import script from "./w8benPage.vue?vue&type=script&lang=js&"
export * from "./w8benPage.vue?vue&type=script&lang=js&"
import style0 from "./w8benPage.vue?vue&type=style&index=0&id=3ec25875&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec25875",
  null
  
)

export default component.exports